
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.763 10.98c.363.464.733 1.044.926 1.396.236.458.334.766.51 1.316.102.303.2.394.404.394.225 0 .327-.154.406-.394.163-.52.29-.914.49-1.291.394-.722.89-1.365 1.375-1.983.133-.173.981-1.192 1.362-2.001 0 0 .467-.884.467-2.119 0-1.155-.46-1.957-.46-1.957l-1.332.364L10.1 6.88l-.2.296-.043.055-.054.069-.091.111-.133.136-.72.599-1.8 1.062-.296 1.773z","fill":"#34A853"}}),_c('path',{attrs:{"d":"M4.904 8.27c.442 1.024 1.284 1.92 1.859 2.71L9.809 7.3s-.43.574-1.206.574A1.575 1.575 0 017.035 6.28c0-.611.357-1.03.357-1.03l-2.064.561-.424 2.458z","fill":"#FBBC04"}}),_c('path',{attrs:{"d":"M9.845 2.285a4.087 4.087 0 012.398 2.063L9.809 7.306s.357-.427.357-1.031c0-.908-.751-1.594-1.563-1.594-.769 0-1.21.568-1.21.568V3.384l2.452-1.1z","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M5.46 3.588c.606-.734 1.666-1.494 3.13-1.494.709 0 1.248.192 1.248.192L7.392 5.25H5.66l-.2-1.663z","fill":"#1A73E8"}}),_c('path',{attrs:{"d":"M4.904 8.27s-.4-.81-.4-1.977c0-1.105.424-2.068.964-2.699l1.931 1.661L4.904 8.27z","fill":"#EA4335"}})])
          )
        }
      }
    